export default __webpack_public_path__ + "static/media/avatar_mice4.4774a784.mp3";